import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { IsLoggedInGuardActions } from '@elio/emanager-front/auth/action';
import { UserSelectors } from '@elio/emanager-front/auth/state';
import { isErrorState } from '@elio/shared/models';
import { filterStatusLoadedOrInError } from '@elio/shared/rxjs-utils';
import { LoggerService } from '@elio/shared/tools/logger';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, Observable, of, timeout } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IsLoggedInGuard {
  private TIMEOUT_USER_LOADING = 10000;

  constructor(
    private store: Store,
    private logger: LoggerService
  ) {}

  canMatch(): Observable<boolean | UrlTree> {
    this.store.dispatch(IsLoggedInGuardActions.loadUser());
    return this.loadUserToCheckIfLoggedIn().pipe(
      map((isLogged: boolean) => isLogged),
      catchError(() => {
        this.logger.error(`Request timed out after: ${this.TIMEOUT_USER_LOADING}ms`);
        return of(false);
      })
    );
  }

  private loadUserToCheckIfLoggedIn(): Observable<boolean> {
    return this.store.select(UserSelectors.getUserCallState).pipe(
      timeout(this.TIMEOUT_USER_LOADING),
      filterStatusLoadedOrInError(), // wait for user to be loaded (in case of page refresh)
      mergeMap((loadingState) => (isErrorState(loadingState) ? of(false) : this.store.select(UserSelectors.isLoggedIn)))
    );
  }
}
